(function () {
  'use strict';

  function initNavigation(root) {
    root.querySelectorAll('[data-uc-nav]').forEach(function (nav) {
      if (nav.dataset.ucReady === 'true') return;

      var toggle = nav.querySelector('[data-uc-nav-toggle]');
      if (!toggle) return;

      nav.dataset.ucReady = 'true';
      toggle.addEventListener('click', function () {
        var open = nav.classList.toggle('is-open');
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      });

      nav.querySelectorAll('a[href^="#"]').forEach(function (link) {
        link.addEventListener('click', function () {
          nav.classList.remove('is-open');
          toggle.setAttribute('aria-expanded', 'false');
        });
      });
    });
  }

  function initProductTabs(root) {
    root.querySelectorAll('[data-uc-tabs]').forEach(function (tabs) {
      if (tabs.dataset.ucReady === 'true') return;
      tabs.dataset.ucReady = 'true';

      var buttons = Array.prototype.slice.call(tabs.querySelectorAll('[data-uc-tab]'));
      var panels = Array.prototype.slice.call(tabs.querySelectorAll('[data-uc-panel]'));

      function activate(name) {
        buttons.forEach(function (button) {
          var active = button.dataset.ucTab === name;
          button.classList.toggle('is-active', active);
          button.setAttribute('aria-selected', active ? 'true' : 'false');
          button.setAttribute('tabindex', active ? '0' : '-1');
        });

        panels.forEach(function (panel) {
          panel.hidden = panel.dataset.ucPanel !== name;
        });
      }

      buttons.forEach(function (button, index) {
        button.addEventListener('click', function () {
          activate(button.dataset.ucTab);
        });

        button.addEventListener('keydown', function (event) {
          if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
          event.preventDefault();
          var direction = event.key === 'ArrowRight' ? 1 : -1;
          var next = (index + direction + buttons.length) % buttons.length;
          buttons[next].focus();
          activate(buttons[next].dataset.ucTab);
        });
      });

      if (buttons.length) activate(buttons[0].dataset.ucTab);
    });
  }

  function initRealResults(root) {
    root.querySelectorAll('[data-uc-real-results]').forEach(function (section) {
      if (section.dataset.ucRealReady === 'true') return;
      section.dataset.ucRealReady = 'true';

      var cardVideos = Array.prototype.slice.call(section.querySelectorAll('.uc-media-card__video'));
      var dialog = section.querySelector('[data-uc-real-dialog]');
      var panels = dialog ? Array.prototype.slice.call(dialog.querySelectorAll('[data-uc-real-panel]')) : [];
      var activeVideoIndex = 0;
      var activePanelIndex = 0;
      var sectionIsVisible = false;
      var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      function pauseCardVideos() {
        cardVideos.forEach(function (video) {
          video.pause();
          var card = video.closest('[data-uc-media-card]');
          if (card) card.classList.remove('is-playing');
        });
      }

      function playCardVideo(index, restart) {
        if (!cardVideos.length || reducedMotion || !sectionIsVisible || (dialog && dialog.open)) return;

        activeVideoIndex = (index + cardVideos.length) % cardVideos.length;
        pauseCardVideos();

        var video = cardVideos[activeVideoIndex];
        if (restart || video.ended) video.currentTime = 0;
        video.muted = true;
        video.playsInline = true;

        var card = video.closest('[data-uc-media-card]');
        if (card) card.classList.add('is-playing');

        var playPromise = video.play();
        if (playPromise && typeof playPromise.catch === 'function') {
          playPromise.catch(function () {
            if (card) card.classList.remove('is-playing');
          });
        }
      }

      cardVideos.forEach(function (video, index) {
        video.loop = false;
        video.muted = true;
        video.playsInline = true;
        video.removeAttribute('autoplay');

        video.addEventListener('ended', function () {
          if (index !== activeVideoIndex) return;
          playCardVideo((index + 1) % cardVideos.length, true);
        });

        video.addEventListener('play', function () {
          cardVideos.forEach(function (otherVideo) {
            if (otherVideo !== video) otherVideo.pause();
          });
        });
      });

      if (cardVideos.length && !reducedMotion && 'IntersectionObserver' in window) {
        var videoObserver = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            sectionIsVisible = entry.isIntersecting && entry.intersectionRatio >= 0.2;
            if (sectionIsVisible) {
              playCardVideo(activeVideoIndex, cardVideos[activeVideoIndex].ended);
            } else {
              pauseCardVideos();
            }
          });
        }, { threshold: [0, 0.2, 0.5] });

        videoObserver.observe(section);
      } else if (cardVideos.length && !reducedMotion) {
        sectionIsVisible = true;
        playCardVideo(0, true);
      }

      function showPanel(index) {
        if (!panels.length) return;

        activePanelIndex = (index + panels.length) % panels.length;

        panels.forEach(function (panel, panelIndex) {
          panel.hidden = panelIndex !== activePanelIndex;
        });

        var activePanel = panels[activePanelIndex];
        var products = activePanel.querySelector('.uc-real-modal__products');
        if (products) products.scrollTop = 0;
      }

      function afterDialogClosed() {
        document.body.classList.remove('uc-modal-open');
        if (sectionIsVisible) playCardVideo(activeVideoIndex, false);
      }

      function closeDialog() {
        if (!dialog) return;
        if (typeof dialog.close === 'function' && dialog.open) {
          dialog.close();
        } else {
          dialog.removeAttribute('open');
          afterDialogClosed();
        }
      }

      function openDialog(index) {
        if (!dialog) return;
        pauseCardVideos();
        document.body.classList.add('uc-modal-open');

        if (typeof dialog.showModal === 'function') {
          if (!dialog.open) dialog.showModal();
        } else {
          dialog.setAttribute('open', '');
        }
        showPanel(index);
      }

      section.querySelectorAll('[data-uc-real-open]').forEach(function (button) {
        button.addEventListener('click', function () {
          openDialog(parseInt(button.dataset.ucRealOpen, 10) || 0);
        });
      });

      if (dialog) {
        var closeButton = dialog.querySelector('[data-uc-real-close]');
        var previousButton = dialog.querySelector('[data-uc-real-previous]');
        var nextButton = dialog.querySelector('[data-uc-real-next]');

        if (closeButton) closeButton.addEventListener('click', closeDialog);
        if (previousButton) previousButton.addEventListener('click', function () { showPanel(activePanelIndex - 1); });
        if (nextButton) nextButton.addEventListener('click', function () { showPanel(activePanelIndex + 1); });

        dialog.addEventListener('cancel', function (event) {
          event.preventDefault();
          closeDialog();
        });

        dialog.addEventListener('close', afterDialogClosed);

        dialog.addEventListener('click', function (event) {
          if (event.target === dialog) closeDialog();
        });
      }

      document.addEventListener('visibilitychange', function () {
        if (document.hidden) {
          pauseCardVideos();
        } else if (sectionIsVisible) {
          playCardVideo(activeVideoIndex, false);
        }
      });

    });
  }

  function initReveal(root) {
    var elements = root.querySelectorAll('.uc-reveal:not([data-uc-reveal-ready])');
    if (!elements.length) return;

    if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      elements.forEach(function (element) {
        element.dataset.ucRevealReady = 'true';
        element.classList.add('is-visible');
      });
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px' });

    elements.forEach(function (element) {
      element.dataset.ucRevealReady = 'true';
      observer.observe(element);
    });
  }

  function init(root) {
    initNavigation(root);
    initProductTabs(root);
    initRealResults(root);
    initReveal(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
